import {
  useDocumentTitle,
  useDocumentTitles,
} from '@client-info/features/branding/hooks';
import { FullHeightPage } from '@client-info/features/shared/FullHeightPage';
import { HeaderWithPolicyTerms } from '@client-info/features/shared/HeaderWithPolicyTerms';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import {
  createFileRoute,
  Outlet,
  retainSearchParams,
} from '@tanstack/react-router';

export const SapConcurLayout = () => {
  useDocumentTitle(useDocumentTitles().sapConcur);

  return (
    <FullHeightPage
      component="section"
      id="sap-concur-layout"
      sx={{ height: '100vh' }}
    >
      <HeaderWithPolicyTerms />
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}
      >
        <Grid
          container
          sx={{ alignItems: 'center', flex: 1, justifyContent: 'center' }}
        >
          <Outlet />
        </Grid>
      </Stack>
    </FullHeightPage>
  );
};

export const Route = createFileRoute('/integrations/connect/sap-concur')({
  component: SapConcurLayout,
  search: { middlewares: [retainSearchParams(true)] },
});
